import { getCurrentPath } from "../common/utils";

export function pageViews(
  callback: (_v: string) => void,
  hashMode = true
): () => void {
  const handleRouteChange = (): void => {
    callback(getCurrentPath(hashMode));
  };

  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  // Override pushState
  history.pushState = function (data, title, url) {
    originalPushState.apply(this, [data, title, url]);
    handleRouteChange();
  };

  // Override replaceState - some SPAs use this for navigation
  history.replaceState = function (data, title, url) {
    originalReplaceState.apply(this, [data, title, url]);
    handleRouteChange();
  };

  window.addEventListener("popstate", handleRouteChange);

  // Attach hashchange listener
  if (hashMode) {
    window.addEventListener("hashchange", handleRouteChange);
  }

  return () => {
    history.pushState = originalPushState;
    history.replaceState = originalReplaceState;
    window.removeEventListener("popstate", handleRouteChange);
    if (hashMode) {
      window.removeEventListener("hashchange", handleRouteChange);
    }
  };
}
